<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { CmsIconName } from "@pkg/cms-icons";
import type { Button } from '@pkg/sanity-utils/types/button';
import type { PortableTextBlock } from 'sanity';

const props = defineProps<{
  block?: {
    icon: CmsIconName,
    content?: {
      title?: Array<PortableTextBlock>,
      subtitle?: Array<PortableTextBlock>,
      _type: string,
      _key: string,
    }[],
    button?: Button,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  icon: props.block?.icon,
  content: props.block?.content,
  button: props.block?.button || undefined,
}));

</script>

<template>
  <div class="wrapper wrapper--content">
    <component :is="props.config?.innerComponent" v-bind="data"/>
  </div>
</template>
